import { on } from '@ember/modifier';
import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { Billing, PopupData, Service } from 'webapp-types';

import BarLoaderComponent from 'webapp/components/bar-loader';
import BillingInvoiceRowComponent from 'webapp/components/billing/invoice-row';
import BillingPopupInvoiceMemoComponent from 'webapp/components/billing/popup-invoice-memo';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class BillingPopupInvoicesComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('billing') declare billingService: Service.Billing;
	@service('request') declare requestService: Service.Request;
	@service('popup') declare popupService: Service.Popup;

	@tracked invoices: Billing.Invoice[] = [];

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.submitInProgress = true;
		this.billingService
			.getInvoices(true)
			.then((invoices) => {
				this.invoices = invoices;
				this.submitInProgress = false;
				this.scheduleReposition();
			})
			.catch(this.requestService.handleGenericThrownError.bind(this.requestService));
	}

	@action
	openModalEditInvoiceMemo() {
		this.popupService.createModal(BillingPopupInvoiceMemoComponent).open(); // <void>
	}
	<template>
		<div class="title">Invoice history</div>

		<div class="content">

			{{#if this.submitInProgress}}
				<BarLoaderComponent @size="big" />
			{{else}}
				<div class="invoices">
					<div class="invoices__content">
						<div class="invoices__table">
							<div class="invoices__table-header">
								<div class="invoices__column"># Invoice</div>
								<div class="invoices__column">Issue date</div>
								<div class="invoices__column">Total</div>
								<div class="invoices__column">Status</div>
							</div>
							{{#each this.invoices as |invoice|}}
								<BillingInvoiceRowComponent
									@model={{invoice}}
									@extendedView={{true}}
								/>
							{{/each}}
						</div>
					</div>

					<div class="invoices__controls">
						<a
							role="button"
							class="invoices__edit-memo"
							{{on "click" this.openModalEditInvoiceMemo}}
						>
							Edit invoice memo
						</a>
						<a role="button" class="button size-big" {{on "click" this.close}}>OK</a>
					</div>

				</div>
			{{/if}}

		</div>
	</template>
}
